<app-toast />
<app-header />
<main>
  <router-outlet />
</main>
<app-footer />
<app-contact-modal />
